"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.createAuthClient = void 0;

var _netlify = require("./netlify");

var _auth = require("./auth0");

var _goTrue = require("./goTrue");

var _magicLink = require("./magicLink");

var _firebase = require("./firebase");

var _custom = require("./custom");

//
var typesToClients = {
  netlify: _netlify.netlify,
  auth0: _auth.auth0,
  goTrue: _goTrue.goTrue,
  magicLink: _magicLink.magicLink,
  firebase: _firebase.firebase,

  /** Don't we support your auth client? No problem, define your own the `custom` type! */
  custom: _custom.custom
};

var createAuthClient = function createAuthClient(client, type) {
  return typesToClients[type](client);
};

exports.createAuthClient = createAuthClient;